import { render, staticRenderFns } from "./xq.vue?vue&type=template&id=f1ef4678&scoped=true"
import script from "./xq.vue?vue&type=script&lang=js"
export * from "./xq.vue?vue&type=script&lang=js"
import style0 from "./xq.vue?vue&type=style&index=0&id=f1ef4678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ef4678",
  null
  
)

export default component.exports